import { _axios } from "../../Utils/Axios/axios";

export const getCities_Service = async () => {
  return _axios.get("/city");
};
